import { escapeRegExp } from '@flight-workspace/common-client/src/util/string';
import {
  IAirport,
  ICity,
  LocationType,
  TLocation,
} from 'common/autocomplete/types';
import Airport from './Airport';
import City from './City';
import Country from './Country';

interface IProps {
  forDeparture: boolean;
  locations: TLocation[];
  query: string;
}

const makeMarkMatchesFunc = (search: string | RegExp) => (target: string) => ({
  __html: target?.replace(
    search,
    match => `<em class="highlight">${match}</em>`,
  ),
});

const Location = ({ forDeparture, locations, query }: IProps) => {
  const search = new RegExp(escapeRegExp(query), 'gi');
  const markMatchedSubstrings = makeMarkMatchesFunc(search);
  const allCities = locations
    .filter(location => location.type === LocationType.CITY)
    .map(city => (city as ICity)?.iataCode);
  const pilferAirportsInCity = locations.filter(
    location =>
      !(
        location.type === LocationType.AIRPORT &&
        allCities.includes((location as IAirport)?.cityCode)
      ),
  );

  return pilferAirportsInCity?.map(location => {
    switch (location.type) {
      case LocationType.COUNTRY:
        return (
          <Country
            country={location}
            forDeparture={forDeparture}
            markMatchedSubstrings={markMatchedSubstrings}
            key={location.countryCode}
          />
        );
      case LocationType.CITY:
        return (
          <City
            city={location}
            forDeparture={forDeparture}
            key={location.iataCode}
            locations={locations}
            markMatchedSubstrings={markMatchedSubstrings}
          />
        );
      case LocationType.AIRPORT:
        return (
          <Airport
            airport={location}
            forDeparture={forDeparture}
            isSubAirport={false}
            key={location.iataCode}
            markMatchedSubstrings={markMatchedSubstrings}
          />
        );
      default:
        return null;
    }
  });
};

export default Location;
